import useSWR from 'swr'

import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useMemo } from 'react'

export type PdvsResponse = {
  pdvs: {
    id: number
    name: string
  }[]
  ocasioes: {
    id: number
    name: string
  }[]
}

export interface useEventPDVsProps {
  eventsPDVS: PdvsResponse
  eventsPDVSLoading: boolean
  eventsPDVSError: AxiosError
}

export const useEventPDVs = (eventId: string): useEventPDVsProps => {
  const url = `/producer/analytics/getEventsPDVs?eventId=${eventId}`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)

  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      eventsPDVS: nestedData,
      eventsPDVSLoading: isLoading,
      eventsPDVSError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
